import { createReducer } from "reduxsauce";

//Custom Imports
import { taskType } from "./actionTypes";
import {
  apiFetchedState,
  getInitialPendingState,
  getNormalApiInitialState,
  getNormalAPIState,
} from "@actions/redux.action";

const initialState = {
  todayDailyTasks: {
    data: {},
    api: getNormalApiInitialState(),
  },
  taskSummary: {
    data: [],
    api: getInitialPendingState(),
  },
  abandonedCartData: {
    data: [],
    api: getInitialPendingState(),
  },
  abandonedBusinessTips: {
    data: [],
    api: getInitialPendingState(),
  },
  abandonedFeedback: {
    data: [],
    api: getInitialPendingState(),
  },

  walletCartData: {
    data: [],
    api: getInitialPendingState(),
  },
  walletBusinessTips: {
    data: [],
    api: getInitialPendingState(),
  },
  walletFeedback: {
    data: [],
    api: getInitialPendingState(),
  },

  promotionCartData: {
    data: [],
    api: getInitialPendingState(),
  },
  promotionBusinessTips: {
    data: [],
    api: getInitialPendingState(),
  },

  taskLoading: false,
  snackbar: false,
  fire: false,
};

const setSuccessStatus = (key, newStatus) => (state, action) => ({
  ...state,
  [key]: {
    ...state[key],
    data: action.payload,
    api: getNormalAPIState(newStatus),
  },
});

const setFetchedSuccessStatus = (key, newStatus) => (state, action) => ({
  ...state,
  [key]: {
    ...state[key],
    data: action.payload,
    api: apiFetchedState(newStatus, state[key].api),
  },
});

const setStatus = (key, newStatus) => (state) => ({
  ...state,
  [key]: {
    ...state[key],
    api: getNormalAPIState(newStatus),
  },
});

const setFetchedStatus = (key, newStatus) => (state) => ({
  ...state,
  [key]: {
    ...state[key],
    api: apiFetchedState(newStatus, state[key].api),
  },
});

const setSingleValue = (key) => (state, action) => ({
  ...state,
  [key]: action.payload,
});

const setShowSnackbarValue = (key) => (state, action) => ({
  ...state,
  [key]: action.payload?.snackbar,
  name: action.payload?.name,
  customer_id: action.payload?.customer_id,
});

const actionHandlers = {
  [taskType.GET_TODAY_TASK_UPCOMING]: setStatus("todayDailyTasks", {
    pending: true,
  }),
  [taskType.GET_TODAY_TASK_SUCCESS]: setSuccessStatus("todayDailyTasks", {
    success: true,
  }),
  [taskType.GET_TODAY_TASK_ERROR]: setStatus("todayDailyTasks", {
    error: true,
  }),

  [taskType.GET_CL_TASK_SUMMARY_UPCOMING]: setFetchedStatus("taskSummary", {
    pending: true,
  }),
  [taskType.GET_CL_TASK_SUMMARY_SUCCESS]: setFetchedSuccessStatus(
    "taskSummary",
    {
      success: true,
    },
  ),
  [taskType.GET_CL_TASK_SUMMARY_ERROR]: setFetchedStatus("taskSummary", {
    error: true,
  }),
  [taskType.GET_CL_TASK_SUMMARY_FETCHED]: setFetchedStatus("taskSummary", {
    fetched: true,
  }),

  [taskType.ABANDONED_CART_UPCOMING]: setFetchedStatus("abandonedCartData", {
    pending: true,
  }),
  [taskType.ABANDONED_CART_SUCCESS]: setFetchedSuccessStatus(
    "abandonedCartData",
    {
      success: true,
    },
  ),
  [taskType.ABANDONED_CART_ERROR]: setFetchedStatus("abandonedCartData", {
    error: true,
  }),
  [taskType.ABANDONED_CART_FETCHED]: setFetchedStatus("abandonedCartData", {
    fetched: true,
  }),

  [taskType.ABANDONED_CART_BUSINESS_UPCOMING]: setFetchedStatus(
    "abandonedBusinessTips",
    {
      pending: true,
    },
  ),
  [taskType.ABANDONED_CART_BUSINESS_SUCCESS]: setFetchedSuccessStatus(
    "abandonedBusinessTips",
    {
      success: true,
    },
  ),
  [taskType.ABANDONED_CART_BUSINESS_ERROR]: setFetchedStatus(
    "abandonedBusinessTips",
    {
      error: true,
    },
  ),
  [taskType.ABANDONED_CART_BUSINESS_FETCHED]: setFetchedStatus(
    "abandonedBusinessTips",
    {
      fetched: true,
    },
  ),

  [taskType.GET_ABANDONED_FEEDBACK_UPCOMING]: setFetchedStatus(
    "abandonedFeedback",
    {
      pending: true,
    },
  ),
  [taskType.GET_ABANDONED_FEEDBACK_SUCCESS]: setFetchedSuccessStatus(
    "abandonedFeedback",
    {
      success: true,
    },
  ),
  [taskType.GET_ABANDONED_FEEDBACK_ERROR]: setFetchedStatus(
    "abandonedFeedback",
    {
      error: true,
    },
  ),
  [taskType.GET_ABANDONED_FEEDBACK_FETCHED]: setFetchedStatus(
    "abandonedFeedback",
    {
      fetched: true,
    },
  ),

  [taskType.GET_WALLET_DATA_TASK_UPCOMING]: setFetchedStatus("walletCartData", {
    pending: true,
  }),
  [taskType.GET_WALLET_DATA_TASK_SUCCESS]: setFetchedSuccessStatus(
    "walletCartData",
    {
      success: true,
    },
  ),
  [taskType.GET_WALLET_DATA_TASK_ERROR]: setFetchedStatus("walletCartData", {
    error: true,
  }),
  [taskType.GET_WALLET_DATA_TASK_FETCHED]: setFetchedStatus("walletCartData", {
    fetched: true,
  }),

  [taskType.WALLET_BUSINESS_TIPS_UPCOMING]: setFetchedStatus(
    "walletBusinessTips",
    {
      pending: true,
    },
  ),
  [taskType.WALLET_BUSINESS_TIPS_SUCCESS]: setFetchedSuccessStatus(
    "walletBusinessTips",
    {
      success: true,
    },
  ),
  [taskType.WALLET_BUSINESS_TIPS_ERROR]: setFetchedStatus(
    "walletBusinessTips",
    {
      error: true,
    },
  ),
  [taskType.WALLET_BUSINESS_TIPS_FETCHED]: setFetchedStatus(
    "walletBusinessTips",
    {
      fetched: true,
    },
  ),

  [taskType.GET_WALLET_FEEDBACK_UPCOMING]: setFetchedStatus("walletFeedback", {
    pending: true,
  }),
  [taskType.GET_WALLET_FEEDBACK_SUCCESS]: setFetchedSuccessStatus(
    "walletFeedback",
    {
      success: true,
    },
  ),
  [taskType.GET_WALLET_FEEDBACK_ERROR]: setFetchedStatus("walletFeedback", {
    error: true,
  }),
  [taskType.GET_WALLET_FEEDBACK_FETCHED]: setFetchedStatus("walletFeedback", {
    fetched: true,
  }),

  [taskType.PROMOTION_BUSINESS_TIPS_UPCOMING]: setFetchedStatus(
    "promotionBusinessTips",
    {
      pending: true,
    },
  ),
  [taskType.PROMOTION_BUSINESS_TIPS_SUCCESS]: setFetchedSuccessStatus(
    "promotionBusinessTips",
    {
      success: true,
    },
  ),
  [taskType.PROMOTION_BUSINESS_TIPS_ERROR]: setFetchedStatus(
    "promotionBusinessTips",
    {
      error: true,
    },
  ),
  [taskType.PROMOTION_BUSINESS_TIPS_FETCHED]: setFetchedStatus(
    "promotionBusinessTips",
    {
      fetched: true,
    },
  ),

  [taskType.GET_PROMOTION_DATA_TASK_UPCOMING]: setFetchedStatus(
    "promotionCartData",
    {
      pending: true,
    },
  ),
  [taskType.GET_PROMOTION_DATA_TASK_SUCCESS]: setFetchedSuccessStatus(
    "promotionCartData",
    {
      success: true,
    },
  ),
  [taskType.GET_PROMOTION_DATA_TASK_ERROR]: setFetchedStatus(
    "promotionCartData",
    {
      error: true,
    },
  ),
  [taskType.GET_PROMOTION_DATA_TASK_FETCHED]: setFetchedStatus(
    "promotionCartData",
    {
      fetched: true,
    },
  ),

  [taskType.SHOW_SNACKBAR_TASK]: setShowSnackbarValue("snackbar"),
  [taskType.CL_TASK_LOADING]: setSingleValue("taskLoading"),
  [taskType.CL_SNACKBAR_LOADING]: setSingleValue("snackbar"),
  [taskType.CL_FIRE_LOADING]: setSingleValue("fire"),
};

export default createReducer(initialState, actionHandlers);
